var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        _vm._b(
          {
            key: _vm.key,
            ref: "time",
            staticClass: "message-time",
            style: {
              width: "100vw",
              marginBottom: _vm.message.id === 1 ? "0vw" : "5.6vw"
            }
          },
          "div",
          _vm.checkShowRule(this.$store.state.messages, "date"),
          false
        ),
        [
          _vm.message.is_show_time
            ? _c("div", [_vm._v(" " + _vm._s(_vm.message.show_time) + " ")])
            : _vm._e()
        ]
      ),
      _c(
        "v-flex",
        {
          ref: "title",
          staticClass: "message",
          style: { "max-width": _vm.message.type !== "bot" ? "105vw" : "" }
        },
        [
          _c(
            "div",
            _vm._b(
              {},
              "div",
              _vm.checkpicture(this.$store.state.messages, "type"),
              false
            ),
            [
              _vm.message.show_photo
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            this.message.type !== "human" &&
                            this.message.id !== 2,
                          expression:
                            "this.message.type !== 'human' && this.message.id !== 2"
                        }
                      ],
                      staticStyle: {
                        width: "44px",
                        height: "44px",
                        float: "left",
                        "border-radius": "50%",
                        overflow: "hidden",
                        "margin-left": "2vw"
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: _vm.toolbarLogo,
                          width: "40",
                          height: "40"
                        }
                      })
                    ]
                  )
                : _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          this.message.type !== "human" &&
                          this.message.id !== 2,
                        expression:
                          "this.message.type !== 'human' && this.message.id !== 2"
                      }
                    ],
                    staticStyle: {
                      width: "44px",
                      height: "44px",
                      float: "left",
                      "border-radius": "50%",
                      overflow: "hidden"
                    }
                  })
            ]
          ),
          _c(
            "v-layout",
            {
              staticClass: "message-layout",
              attrs: { column: "", "ma-2": "" }
            },
            [
              _c(
                "v-flex",
                {
                  staticClass: "message-bubble-date-container",
                  style: {
                    marginLeft: _vm.message.type === "human" ? "-5vw" : ""
                  }
                },
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "message-bubble-column",
                      style: { width: "100%" },
                      attrs: { column: "" }
                    },
                    [
                      _c(
                        "v-flex",
                        {
                          directives: [{ name: "scroll", rawName: "v-scroll" }],
                          ref: "cards",
                          staticClass: "message-bubble-avatar-container"
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              staticClass: "message-bubble-row",
                              style: {
                                "flex-direction":
                                  _vm.message.type === "human"
                                    ? "row-reverse"
                                    : _vm.message.id !== 1 &&
                                      _vm.message.id !== 2 &&
                                      _vm.message.id !== 0 &&
                                      !_vm.message.responseCard
                                    ? "column"
                                    : "",
                                display: "flex",
                                "max-width": "105vw",
                                "align-items": "center"
                              },
                              attrs: { row: "" }
                            },
                            [
                              _vm.shouldShowAvatarImage
                                ? _c("div", {
                                    staticClass: "avatar",
                                    style: _vm.avatarBackground,
                                    attrs: {
                                      tabindex: "-1",
                                      "aria-hidden": "true"
                                    }
                                  })
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "message-bubble focusable",
                                  style: {
                                    display: _vm.message.responseCard ? "" : "",
                                    "font-family": _vm.message.responseCard
                                      ? ""
                                      : "",
                                    width:
                                      _vm.message.type === "bot"
                                        ? "100%"
                                        : "auto",
                                    width: _vm.message.id === 2 ? "1500vw" : "",
                                    height: _vm.message.id === 2 ? "auto" : "",
                                    "padding-right":
                                      _vm.message.id === 2 ? "7vw" : "",
                                    marginRight:
                                      _vm.message.id === 2 ? "4vw" : "",
                                    marginLeft: _vm.message.responseCard
                                      ? ""
                                      : _vm.message.type === "bot"
                                      ? "-1.2vw"
                                      : "4vw",
                                    fontSize:
                                      _vm.message.id === 2 ? "1.5rem" : "",
                                    "border-bottom-right-radius":
                                      _vm.message.type === "human"
                                        ? "40px"
                                        : _vm.message.type === "bot" &&
                                          _vm.message.id !== 2 &&
                                          this.BubbleHeight > 190
                                        ? "0px"
                                        : "24px",
                                    "border-bottom-left-radius":
                                      _vm.message.type === "human"
                                        ? "40px"
                                        : _vm.message.type === "bot" &&
                                          _vm.message.id !== 2 &&
                                          this.BubbleHeight > 190
                                        ? "0px"
                                        : "24px",
                                    background:
                                      _vm.message.id === 2 ? "none" : "",
                                    "border-top-left-radius": _vm.message
                                      .responseCard
                                      ? "0px"
                                      : _vm.message.type === "human"
                                      ? "40px"
                                      : "24px",
                                    "border-top-right-radius":
                                      _vm.message.type === "human" ? "0px" : "",
                                    "padding-bottom":
                                      _vm.message.text === "Aww"
                                        ? "6vw"
                                        : _vm.message.type === "bot" &&
                                          _vm.message.id === 2
                                        ? "4vw"
                                        : _vm.message.type === "bot" &&
                                          _vm.message.id !== 2 &&
                                          this.BubbleHeight > 190
                                        ? "0vw"
                                        : _vm.message.type === "bot" &&
                                          _vm.message.id !== 2 &&
                                          _vm.message.id !== 0 &&
                                          _vm.message.id !== 1 &&
                                          !_vm.message.responseCard
                                        ? "6vw"
                                        : "",
                                    height:
                                      _vm.message.type === "bot" &&
                                      _vm.message.id !== 2 &&
                                      this.message.alts &&
                                      this.message.alts.markdown &&
                                      this.brandFold &&
                                      this.BubbleHeight > 190
                                        ? "42vw"
                                        : "",
                                    "padding-left":
                                      _vm.message.type === "human" ? 0 : "",
                                    padding:
                                      _vm.message.id === 2
                                        ? "0px !important"
                                        : ""
                                    /* flex-direction: row-reverse; */
                                  },
                                  attrs: { tabindex: "0", id: "message-bubble" }
                                },
                                [
                                  this.message.text === "Aww" ||
                                  this.message.text === "啊哇" ||
                                  this.message.text === "ああ" ||
                                  this.message.text === "噢"
                                    ? _c(
                                        "div",
                                        { style: { display: "flex" } },
                                        [
                                          this.message.type === "bot" &&
                                          this.message.text == "Aww"
                                            ? _c(
                                                "div",
                                                {
                                                  style: {
                                                    marginLeft: "2vw",
                                                    marginTop: "2vw"
                                                  }
                                                },
                                                [
                                                  _vm.from !== "login"
                                                    ? _c("div", [
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "licence.Robot_closing_1_1"
                                                              )
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "licence.Robot_closing_1_2"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.flag &&
                                                                  _vm.pushFeedback()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "licence.Robot_closing_2"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "licence.Robot_closing_3"
                                                            )
                                                          ) + " "
                                                        )
                                                      ])
                                                    : _c("div", [
                                                        _c("div", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "licence.Robot_closing_1_login_1"
                                                                )
                                                              ) +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "licence.Robot_closing_1_login_2"
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ])
                                                      ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  this.message.text === "Sorry"
                                    ? _c(
                                        "div",
                                        { style: { display: "flex" } },
                                        [
                                          this.message.text == "Sorry"
                                            ? _c(
                                                "div",
                                                {
                                                  style: {
                                                    marginLeft: "2vw",
                                                    marginTop: "2vw",
                                                    hyphens: "auto"
                                                  }
                                                },
                                                [
                                                  _vm.from !== "login"
                                                    ? _c("div", [
                                                        _vm._v(
                                                          " I'm sorry I didn't help you with your problem. Please rephrase it or click the button below to get further help. Also, you can click "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.flag &&
                                                                  _vm.pushFeedback()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "licence.Robot_closing_2"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "to contact our Support Team. "
                                                        )
                                                      ])
                                                    : _c("div", [
                                                        _c("div", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "licence.Robot_closing_1_login_1"
                                                                )
                                                              ) +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "licence.Robot_closing_1_login_2"
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ])
                                                      ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      ref: "bubble",
                                      style: {
                                        overflow:
                                          _vm.message.id === 2 ||
                                          _vm.message.responseCard
                                            ? ""
                                            : "hidden",
                                        height:
                                          _vm.message.type === "bot" &&
                                          _vm.message.id !== 2 &&
                                          this.message.alts &&
                                          this.message.alts.markdown &&
                                          this.brandFold &&
                                          this.BubbleHeight > 190
                                            ? "42vw"
                                            : "",
                                        "margin-bottom":
                                          _vm.message.type === "bot" &&
                                          _vm.message.id !== 2 &&
                                          this.message.alts &&
                                          this.message.alts.markdown &&
                                          this.brandFold &&
                                          this.BubbleHeight > 190
                                            ? "-3vw"
                                            : "",
                                        marginLeft:
                                          _vm.message.type === "bot" &&
                                          _vm.message.id !== 2 &&
                                          !_vm.message.responseCard
                                            ? "-4vw"
                                            : "",
                                        "padding-left":
                                          _vm.message.type === "bot" &&
                                          _vm.message.id !== 2 &&
                                          _vm.message.alts &&
                                          _vm.message.alts.markdown
                                            ? "1em"
                                            : "",
                                        "font-weight": !_vm.message.responseCard
                                          ? ""
                                          : this.$i18n.locale === "tc" ||
                                            "zh" ||
                                            "ja"
                                          ? "900"
                                          : ""
                                      }
                                    },
                                    [
                                      "text" in _vm.message &&
                                      _vm.message.text !== null &&
                                      _vm.message.text.length
                                        ? _c("message-text", {
                                            ref: "textBox",
                                            style: {},
                                            attrs: { message: _vm.message }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm.message.type === "bot" &&
                                  _vm.botDialogState &&
                                  _vm.showDialogStateIcon
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "dialog-state",
                                          class:
                                            "dialog-state-" +
                                            _vm.botDialogState.state,
                                          attrs: { medium: "" }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.botDialogState.icon) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.message.type === "human" &&
                                  _vm.message.audio
                                    ? _c(
                                        "div",
                                        [
                                          _c("audio", [
                                            _c("source", {
                                              attrs: {
                                                src: _vm.message.audio,
                                                type: "audio/wav"
                                              }
                                            })
                                          ]),
                                          _c(
                                            "v-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !_vm.showMessageMenu,
                                                  expression: "!showMessageMenu"
                                                }
                                              ],
                                              staticClass:
                                                "icon-color ml-0 mr-0",
                                              attrs: {
                                                tabindex: "0",
                                                icon: ""
                                              },
                                              on: { click: _vm.playAudio }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { staticClass: "play-icon" },
                                                [_vm._v("play_circle_outline")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.message.type === "human"
                                    ? _c(
                                        "v-menu",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.showMessageMenu,
                                              expression: "showMessageMenu"
                                            }
                                          ],
                                          attrs: { "offset-y": "" }
                                        },
                                        [
                                          _c(
                                            "v-list",
                                            [
                                              _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-list-tile-title",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.resendMessage(
                                                            _vm.message.text
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("replay")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm.message.type === "human" &&
                                              _vm.message.audio
                                                ? _c(
                                                    "v-list-tile",
                                                    {
                                                      staticClass:
                                                        "message-audio"
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-tile-title",
                                                        {
                                                          on: {
                                                            click: _vm.playAudio
                                                          }
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "play_circle_outline"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        this.BubbleHeight > 190 &&
                                        _vm.message.alts &&
                                        _vm.message.alts.markdown &&
                                        _vm.message.type === "bot" &&
                                        _vm.message.id !== 1 &&
                                        _vm.message.id !== 2 &&
                                        _vm.showDialogFeedback &&
                                        _vm.botDialogState,
                                      expression:
                                        "\n                   this.BubbleHeight > 190 &&\n                   message.alts &&\n                   message.alts.markdown &&\n                   message.type === 'bot' &&\n                   message.id !== 1 && \n                   message.id !== 2 &&\n                   showDialogFeedback &&\n                   botDialogState\n                 "
                                    }
                                  ],
                                  style: {
                                    "background-color": "white",
                                    width: "101.55%",
                                    "margin-bottom": "0rem",
                                    padding: "5vw",
                                    "padding-top": "4vw",
                                    "padding-bottom": "5.5vw",
                                    "margin-left": "-0.9vw",
                                    "border-bottom-right-radius": "24px",
                                    "border-bottom-left-radius": "24px",
                                    "-webkit-touch-callout": "none"
                                  },
                                  on: { click: _vm.changeFoldState }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-direction": "row",
                                        "justify-content": "center",
                                        color: "#0a79c3",
                                        "font-size": "1rem"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.brandFold
                                            ? _vm.$t(
                                                "licence.Robot_massege_ViewMore"
                                              )
                                            : _vm.$t(
                                                "licence.Robot_massege_ViewLess"
                                              )
                                        ) + " "
                                      ),
                                      _c("img", {
                                        staticStyle: { margintop: "-0.8vw" },
                                        style: {
                                          transform: _vm.brandFold
                                            ? "rotate(-180deg)"
                                            : ""
                                        },
                                        attrs: {
                                          src: require("../assets/up@2x.png"),
                                          width: "22",
                                          height: "22"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.shouldDisplayResponseCard
                        ? _c(
                            "v-flex",
                            {
                              ref: "card",
                              staticClass: "response-card",
                              attrs: { "d-flex": "" },
                              on: { click: _vm.cardTest }
                            },
                            _vm._l(
                              _vm.message.responseCard.genericAttachments,
                              function(card, index) {
                                return _c("response-card", {
                                  key: index,
                                  style: {
                                    "background-color": "#FAFAFA !important"
                                  },
                                  attrs: { "response-card": card }
                                })
                              }
                            ),
                            1
                          )
                        : _vm._e(),
                      !_vm.message.responseCard &&
                      _vm.message.type !== "human" &&
                      _vm.message.id !== 0 &&
                      _vm.message.id !== 1 &&
                      _vm.message.id !== 2 &&
                      this.message.text !== "啊哇" &&
                      this.message.text !== "ああ" &&
                      this.message.text !== "噢" &&
                      this.message.text !== "Aww" &&
                      this.message.text !== "Sorry"
                        ? _c(
                            "div",
                            {
                              staticClass: "showme",
                              style: {
                                display: "flex",
                                marginBottom: "-2vw",
                                marginTop: "3vw",
                                width: "fit-content"
                              },
                              attrs: { id: "show" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "feedback-btn",
                                  style: {
                                    border: _vm.positiveClick ? "" : "",
                                    color: "transparent",
                                    background: _vm.positiveClick
                                      ? "-webkit-linear-gradient(left,#FF8E52,#F3A850)"
                                      : ""
                                  },
                                  attrs: { text: "", icon: "", tabindex: "0" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onButtonClick(
                                        _vm.positiveIntent
                                      )
                                    }
                                  }
                                },
                                [
                                  !_vm.positiveClick
                                    ? _c("img", {
                                        attrs: {
                                          src: require("../assets/happyface@2x.png"),
                                          width: "23vw",
                                          height: "23vw"
                                        }
                                      })
                                    : _c("img", {
                                        attrs: {
                                          src: require("../assets/happyface-light@2x.png"),
                                          width: "23vw",
                                          height: "23vw"
                                        }
                                      }),
                                  !_vm.positiveClick
                                    ? _c(
                                        "div",
                                        {
                                          style: {
                                            color: "#999999",
                                            marginLeft: "1vw",
                                            "font-weight": 400
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "licence.Robot_problem_solved"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          style: {
                                            color: "#fff",
                                            marginLeft: "1vw",
                                            "font-weight": 400
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "licence.Robot_problem_solved"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "feedback-btn",
                                  style: {
                                    border: _vm.negativeClick ? "" : "",
                                    color: "transparent",
                                    fontweight: _vm.negativeClick ? "200" : "",
                                    background: _vm.negativeClick
                                      ? "-webkit-linear-gradient(left,#FF3846,#F85B66)"
                                      : ""
                                  },
                                  attrs: {
                                    text: "",
                                    dark: "",
                                    icon: "",
                                    tabindex: "0"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onButtonClick(
                                        _vm.negativeIntent
                                      )
                                    }
                                  }
                                },
                                [
                                  !_vm.negativeClick
                                    ? _c("img", {
                                        style: {},
                                        attrs: {
                                          src: require("../assets/unhappyface@2x.png"),
                                          width: "23vw",
                                          height: "23vw"
                                        }
                                      })
                                    : _c("img", {
                                        attrs: {
                                          src: require("../assets/unhappyface-light@2x.png"),
                                          width: "23vw",
                                          height: "23vw"
                                        }
                                      }),
                                  !_vm.negativeClick
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "div",
                                          style: {
                                            color: "#999999",
                                            marginLeft: "1vw",
                                            "font-weight": 400
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "licence.Robot_problem_unsolved"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.negativeClick
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "div",
                                          style: {
                                            color: "#fff",
                                            marginLeft: "1vw",
                                            "font-weight": 400
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "licence.Robot_problem_unsolved"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.shouldDisplayResponseCardV2 && !_vm.shouldDisplayResponseCard
                ? _c("v-flex")
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }